import Eyebrow from '@/components/Eyebrow/Eyebrow';
import Heading from '@/components/Heading/Heading';
import useGlobalStyles, { ResponsiveTypeVariant } from '@/styles/global.styles';
import useStyles from './StatCardContent.styles';

interface StatCardContentProps {
  className?: string;
  subheadingClassName?: string;
  eyebrow?: string;
  heading?: string;
  subheading?: string;
  isOnDark?: boolean;
  fixed?: boolean;
  subheadingFontStyle?:
    | ResponsiveTypeVariant.body
    | ResponsiveTypeVariant.bodyLg;
  headingSpacingValue?: 0 | 1;
}

const StatCardContent = ({
  className,
  subheadingClassName,
  eyebrow,
  heading,
  subheading,
  isOnDark = true,
  fixed = true,
  subheadingFontStyle = ResponsiveTypeVariant.body,
  headingSpacingValue = 0,
}: StatCardContentProps): React.JSX.Element => {
  const { classes: globalClasses } = useGlobalStyles({ fixed });
  const { classes, cx } = useStyles({ headingSpacingValue });

  return (
    <div
      className={cx(
        classes.contentContainer,
        isOnDark ? classes.onDark : classes.onLight,
        className
      )}
    >
      {eyebrow && <Eyebrow text={eyebrow} isOnDark={isOnDark} />}
      {heading && (
        <Heading
          level='h3'
          classNameOverride={cx(globalClasses.h4, 'primaryTextColor')}
        >
          {heading}
        </Heading>
      )}
      {subheading && (
        <p
          className={cx(
            classes.subheading,
            globalClasses[subheadingFontStyle],
            'accentTextColor',
            subheadingClassName
          )}
        >
          {subheading}
        </p>
      )}
    </div>
  );
};

export default StatCardContent;
